import { api, ApiResponse } from './api'
import { User } from '../types/auth'

export interface CreateUserRequest {
  email: string
  username: string
  password: string
  firstName?: string
  lastName?: string
  isActive?: boolean
  roleIds?: number[]
}

export interface UpdateUserRequest {
  email?: string
  username?: string
  firstName?: string
  lastName?: string
  isActive?: boolean
  roleIds?: number[]
  password?: string
}

export interface UsersResponse {
  data: User[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
  }
}

export interface AssignRoleRequest {
  roleId: number
}

export const userService = {
  async getUsers(page: number = 1, limit: number = 10, search?: string): Promise<UsersResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    })
    
    if (search) {
      params.append('search', search)
    }
    
    const response = await api.get<ApiResponse<UsersResponse>>(`/users?${params}`)
    return response.data.data
  },

  async getUserById(id: number): Promise<User> {
    const response = await api.get<ApiResponse<User>>(`/users/${id}`)
    return response.data.data
  },

  async createUser(data: CreateUserRequest): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/users', data)
    return response.data.data
  },

  async updateUser(id: number | string, data: UpdateUserRequest): Promise<User> {
    const response = await api.patch<ApiResponse<User>>(`/users/${id}`, data)
    return response.data.data
  },

  async deleteUser(id: number | string): Promise<void> {
    await api.delete(`/users/${id}`)
  },

  async assignRole(userId: number, roleId: number): Promise<void> {
    await api.post(`/users/${userId}/roles`, { roleId })
  },

  async removeRole(userId: number, roleId: number): Promise<void> {
    await api.delete(`/users/${userId}/roles`, { data: { roleId } })
  },

  async getUserRoles(userId: number): Promise<any[]> {
    const response = await api.get(`/users/${userId}/roles`)
    return response.data
  }
}
